export default class Pagamento {
  constructor(valorPago = 0, idFormaPagamento = 0, formaPagamento = "", dataPagamento = "") {
    this.ValorPago = valorPago
    this.IdFormaPagamento = idFormaPagamento
    this.FormaPagamento = formaPagamento
    this.DataPagamento = dataPagamento
  }
}
